import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { languages } from 'src/i18n/config';
import { ScrollTrigger } from 'src/utils/gsap';
import { prefersReducedMotion } from 'src/utils/motion';

import style from './LanguageSwitcher.module.scss';

const LanguageSwitcher = ({ className }) => {
  const { i18n, t } = useTranslation();

  // Fade the page out, swap texts, fade back in
  const changeLanguage = (lang) => {
    if (lang === i18n.resolvedLanguage) return;
    if (prefersReducedMotion) {
      i18n.changeLanguage(lang);
      return;
    }

    const html = document.documentElement;
    html.classList.add('lang-swap');
    setTimeout(async () => {
      await i18n.changeLanguage(lang);
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
        html.classList.remove('lang-swap');
      });
    }, 280);
  };

  return (
    <div
      className={cn(style.lang, className)}
      role='group'
      aria-label={t('navigation.language')}
    >
      {languages.map((lang) => (
        <button
          key={lang}
          type='button'
          aria-pressed={i18n.resolvedLanguage === lang}
          onClick={() => changeLanguage(lang)}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
